import React from "react";
import { TicketReceiver } from '../../../types/qztray/QzTrayTypes';
import { getTicketReceiverFields } from '../../../features/printing/ticketReceiver';

interface TicketInfoBodyProps {
  printerName?: string;
  printerType?: string;
  createdAt?: string;
  referenceId?: string;
  receiver?: TicketReceiver | null;
  documentContext?: 'SALE' | 'PURCHASE';
}

/**
 * 📄 TicketInfoBody
 *
 * Versión ajustada para mostrar todo en vertical.
 */
const TicketInfoBody: React.FC<TicketInfoBodyProps> = ({
  printerName = "POS-80",
  printerType = "Thermal",
  createdAt = "2025-10-20 16:35:00",
  referenceId = "SALE-000152",
  receiver,
  documentContext = 'SALE',
}) => {
  const receiverFields = getTicketReceiverFields(receiver, documentContext);
  return (
    <div className="px-6 py-4 text-sm text-gray-700 dark:text-bodydark space-y-3 transition-colors duration-200">
      
      {/* 🔹 Nombre y tipo */}
      <div>
        <p className="text-base font-semibold text-body dark:text-white leading-none">
          {printerName}
        </p>
        <p className="text-xs text-body dark:text-gray-400 mt-0.5">
          {printerType} printer
        </p>
      </div>

      <hr className="border-stroke dark:border-strokedark" />

      {/* 🔹 Todo vertical */}
      <div className="flex flex-col gap-2 text-[13px]">

        <p>
          <span className="font-medium text-body dark:text-gray-200">
            Fecha:
          </span>{" "}
          <span className="text-gray-600 dark:text-gray-400">{createdAt}</span>
        </p>

        <p>
          <span className="font-medium text-body dark:text-gray-200">
            Referencia:
          </span>{" "}
          <span className="text-gray-600 dark:text-gray-400">{referenceId}</span>
        </p>

      </div>

      {receiverFields.length > 0 && (
        <>
          <hr className="border-stroke dark:border-strokedark" />
          <div className="flex flex-col gap-2 text-[13px]" data-testid="ticket-receiver">
            {receiverFields.map((field) => (
              <p key={field.label}>
                <span className="font-medium text-body dark:text-gray-200">{field.label}:</span>{' '}
                <span className="text-gray-600 dark:text-gray-400">{field.value}</span>
              </p>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default TicketInfoBody;
